import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { Box, List, ListItem, ListItemIcon, Skeleton } from '@mui/material';
import { ListItemContainer } from './list-item-container';
import { SocialAccountsBox } from './social-accounts-box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingSocialAccounts = function LoadingSocialAccounts() {
  var inColumnView = useContainerMediaQuery({
    maxWidth: 'md'
  });
  return /*#__PURE__*/_jsx(SocialAccountsBox, {
    "data-element": "SocialAccountsBox",
    "data-component": "LoadingSocialAccounts",
    "data-source-file": "loading.tsx",
    children: /*#__PURE__*/_jsx(List, {
      "data-element": "List",
      "data-component": "LoadingSocialAccounts",
      "data-source-file": "loading.tsx",
      children: Array.from(Array(5).keys()).map(function (i) {
        return /*#__PURE__*/_jsxs(ListItem, {
          component: ListItemContainer,
          children: [/*#__PURE__*/_jsx(ListItemIcon, {
            children: /*#__PURE__*/_jsx(Skeleton, {
              variant: "rectangular",
              width: 40,
              height: 40
            })
          }), /*#__PURE__*/_jsxs(Box, {
            sx: {
              flex: 1
            },
            children: [/*#__PURE__*/_jsx(Skeleton, {
              width: inColumnView ? 60 : 120,
              height: 28
            }), /*#__PURE__*/_jsx(Skeleton, {
              width: inColumnView ? 100 : 200,
              height: 20
            })]
          })]
        }, i);
      })
    })
  });
};

export default LoadingSocialAccounts;